import { EventEmitter } from 'fbemitter';
/* eslint-disable */
export default new EventEmitter();